import { render } from "./PushNotificationManager.vue?vue&type=template&id=1adaa8f2"
import script from "./PushNotificationManager.vue?vue&type=script&lang=js"
export * from "./PushNotificationManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__